import {textFilterParamsValues} from "../reactTableController";
import { booleanFilterParams, getBooleanValueGetter } from "../../utils/booleanColUtils";

export const defaultSortModel = [
    {
        colId: 'f61BookDate',
        sort: 'desc',
        sortIndex: 0
    }
];
export const reactTransactionCols = function (translate, filterFormatter, transactionTypesPromise, fractionDigits,
    { showCamt052 = false, showCamt053 = false} = {}
) {
    const cols = [{
        field: "f61BookDate",
        headerName: translate.instant('BOOK_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.f61BookDate) : "";
        }
    }, {
        field: "f61ValueDate",
        headerName: translate.instant('VALUE_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.f61ValueDate) : "";
        }
    }, {
        field: "infoToAccOwner",
        headerName: translate.instant('BOOK_TEXT'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues,
        tooltipValueGetter: (params) => {
            return params.data ? params.data.bookingText : "";
        }
    }, {
        field: "supplementaryText",
        headerName: translate.instant('SUPPLEMENT_TEXT'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "accountOwnerRef",
        headerName: translate.instant('ACC_OWN_REF'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    }, {
        field: "transactionType",
        headerName: translate.instant('TRANSACTION_TYPE'),
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: {
            values: (params) => {
                transactionTypesPromise.then(data => params.success(data.map(it => it.code)));
            }}
    }, {
        field: "debit",
        headerName: translate.instant('DEBIT_AMOUNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.debit, fractionDigits) : "";
        }
    }, {
        field: "credit",
        headerName: translate.instant('CREDIT_AMOUNT'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.credit, fractionDigits) : "";
        }
    }, {
        field: "balance",
        headerName: translate.instant('BALANCE'),
        sortable: false,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.balance, fractionDigits) : "";
        }
    }];

    if (showCamt052) {
        cols.push({
            field: "camt052",
            headerName: translate.instant('CAMT052'),
            sortable: true,
            filter: 'agSetColumnFilter',
            filterParams: booleanFilterParams('camt052', translate),
            valueGetter: getBooleanValueGetter('camt052', translate),
            initialHide: true
        });
    }

    if (showCamt053) {
        cols.push({
            field: "camt053",
            headerName: translate.instant('CAMT053'),
            sortable: true,
            filter: 'agSetColumnFilter',
            filterParams: booleanFilterParams('camt053', translate),
            valueGetter: getBooleanValueGetter('camt053', translate),
            initialHide: true
        });
    }

    return cols;
}
